










import { CurrencyCode, LoadingStatusType, Locales } from "@/enums/enums";
import { GetCurrencyCode } from "@/helper/shareHelper";
import { OnlineViewModel } from "@/model/document/documentModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreDocument = namespace("Document");

@Component
export default class SwitchCurrency extends Vue {
  @Prop({ default: false }) readonly isMobile!: boolean;

  private currencyText: any = "";
  private toCurrency: CurrencyCode = CurrencyCode.THB;
  private currencyCode = "";

  @StoreDocument.Getter
  private getDocumentDetail!: OnlineViewModel | null;
  @StoreDocument.Getter
  private getDocumentLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getSwitchCurrency!: CurrencyCode;

  @StoreDocument.Mutation
  private SetSwitchCurrency!: (currency: CurrencyCode) => void;

  @Watch("getDocumentLoadingStatus", { immediate: true })
  getDocumentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getDocumentDetail instanceof OnlineViewModel && this.getDocumentDetail?.document) {
        this.toCurrency = this.getDocumentDetail.document.data.currency.toCurrency.currencyCode;
        this.currencyCode = GetCurrencyCode(this.toCurrency);
        this.SetSwitchCurrency(this.toCurrency);
      }
    }
  }

  @Watch("getSwitchCurrency", { immediate: true })
  getSwitchCurrencyChanged() {
    this.SetSwitchCurrencyText();
  }

  @Watch("$i18n.locale")
  langsChanged() {
    this.SetSwitchCurrencyText();
  }

  SetSwitchCurrencyText() {
    if (this.getSwitchCurrency === CurrencyCode.THB) {
      this.currencyText = this.$t("Convert_To_Other_Currency", { currency: this.currencyCode });
    } else {
      this.currencyText = this.$t("Convert_To_THB");
    }
  }

  SetStateSwitchCurrency() {
    if (this.getSwitchCurrency === CurrencyCode.THB) {
      this.SetSwitchCurrency(this.toCurrency);
    } else {
      this.SetSwitchCurrency(CurrencyCode.THB);
    }
  }
}
